import threeGuaranteesdispatch from './threeGuaranteesdispatch'
import catchEdit from './catchEdit'
export default {
    ...threeGuaranteesdispatch,
    ...catchEdit,
}
